import React, { useEffect, useState } from 'react'
import InformationErrorModal from './Components/Modals/InformationErrorModal'
import { useAuth } from '../Providers/AuthProvider';
import version from '../../package.json'

const VersionControl = () => {
    const { logout } = useAuth()
    const [isUpdate, setIsUpdate] = useState(false)
    const currentVersion = version.version

    useEffect(() => {
        const storedVersion = localStorage.getItem('APP_VERSION')
        if (storedVersion && storedVersion !== currentVersion) {
            setIsUpdate(true)
        }
        if (!storedVersion) { //nie było trzymanej strony wiec zapisujemy do pamięci obecną wersje
            localStorage.setItem('APP_VERSION', currentVersion)
        }
    }, [])
    const handleUpdate = () => {
        localStorage.setItem('APP_VERSION', currentVersion)
        setIsUpdate(false)
        logout(true, true)
    }

    return (
        <InformationErrorModal
            show={isUpdate}
            setShow={handleUpdate}
            title={'Nowa wersja!'}
            message={'Uwaga wykryto nową wersję aplikacji, aby kontynuować niezbędne jest przeładowanie aplikacji!'}
            isError={false}
            isVersionControlInfo={true}
        />
    )
}

export default VersionControl